import { trackEvent as webxTrackEvt, xenv } from '@didi/webx-js'
import UAParser from 'ua-parser-js'
import { getPubData, isMobile, getUrlParams, getFpUid, getSlider } from '../utils'
import eventMap from './event-map.js'

const uaInfo = new UAParser().getResult() || {}
const { browser, device, os } = uaInfo
const noPidEvtIdArr = [
  'userteam_ad_zj_begin_en',
  'userteam_ad_zj_login_pre_bt',
  'userteam_ad_zj_login_success_bt',
  'userteam_ad_zj_loadpage_time_bt'
]

let abTestParams = {}

const getCommonParams = () => {
  const urlParams = getUrlParams()
  const { cid, creativeid, creative_id } = urlParams
  const xid = getPubData('xid')
  return {
    ...abTestParams,
    ...urlParams,
    client_type: isMobile() ? 'mobile' : 'pc',
    lp_type: xenv(),
    browser_type: browser?.name || '',
    browser_version: browser?.version || '',
    device_model: device?.model || '',
    device_vender: device?.vendor || '',
    os_type: os?.name || '',
    os_version: os?.version || '',
    page_url: __isServerRender__ ? '' : window.location.href,
    ua: __isServerRender__ ? '' : window.navigator.userAgent,
    creative_id: cid || creativeid || creative_id,
    xid: xid || urlParams.xid
  }
}
export function addAbTestParams (params) {
  abTestParams = params
}

let strategyId = ''

function getStrategyId (params) {
  if (strategyId) return strategyId
  strategyId = params.strategyId || getPubData('strategyId') || ''
  return strategyId
}

/**
 * 发起埋点请求
 */
let startTime = 0
export async function trackEvent (key, params = {}) {
  if (key === 'userteam_ad_zj_pub_sw' && params.type === 'slider') {
    const trackSlider = getSlider(params)
    if (!trackSlider) return
    trackSlider.banners.push(params.banner_num)
  }
  let timecost = new Date().getTime() - startTime
  if (!noPidEvtIdArr.includes(key)) {
    const pid = await getFpUid()
    params.pub_didiad_ad_pid = pid
  }
  if (key === 'userteam_ad_zj_begin_en') {
    timecost = 0
    startTime = new Date().getTime()
  }
  const xak = getPubData('xak')
  const template_type = getPubData('template_type')
  params.strategyId = getStrategyId(params)
  params.template_type = template_type
  params.xak = xak
  const totalParams = { ...getCommonParams(), timecost, ...params }
  webxTrackEvt(key, params.label || eventMap[key], totalParams)
}
